
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["ldi-z1mv4x",classNames,staticClass],
              style: [{"background":"0 0"},style,staticStyle],
              attrs: Object.assign({"class":"ldi-z1mv4x","width":"135","height":"135","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","style":"background:0 0"}, attrs),
              ...rest,
            },
            children.concat([_c('svg',{staticStyle:{"transform-origin":"50px 50px 0"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 100 100","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"d":"M32 57.7L7.5 42.5v22.9c0 3 2.4 5.4 5.4 5.4h43.7c3 0 5.4-2.4 5.4-5.4V42.5L37.5 57.7c-1.7 1.1-3.8 1.1-5.5 0z","fill":"#023F99"}}),_c('path',{attrs:{"d":"M11.1 39.8l21.1 13.1c.8.5 1.7.7 2.6.7.9 0 1.8-.2 2.6-.7l21.1-13.1c2.3-1.4 3.6-3.8 3.6-6.5 0-2.2-1.8-4-4-4H11.5c-2.2 0-4 1.8-4 4 0 2.6 1.4 5.1 3.6 6.5z","fill":"#023F99"}})])])])
          )
        }
      }
    